export const classes = {
  badge:
    'inline-flex items-center justify-center px-2 py-0 rounded-full border border-white/35 bg-gradient-to-br from-white/40 to-white/15 text-white text-xs font-semibold tracking-wider uppercase',
};
